<template>
  <div>
    <div class="space-between-y">
      <div class="space-between-x container-left">
        <input-item label="金额">
          <el-input placeholder="请输入金额" v-model="form.amount"></el-input>
        </input-item>
        <input-item label="支付方式">
          <el-select v-model="form.paymentMethod" placeholder="请选择支付方式">
            <el-option label="支付宝" value="ALIPAY"/>
            <el-option label="银行卡" value="BANK"/>
            <el-option label="现金" value="CASH"/>
          </el-select>
        </input-item>
        <input-item label="支付时间">
          <el-date-picker
              v-model="form.paymentTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期">
          </el-date-picker>
        </input-item>
      </div>

      <div class="space-between-x container-left">
        <input-item label="付款方">
          <input-auto-tip placeholder="请输入付款方" v-model="form.payer" :tip-list="option.payers"></input-auto-tip>
        </input-item>
        <input-item label="收款方">
          <input-auto-tip placeholder="请输入收款方" v-model="form.receiver"
                          :tip-list="option.receivers"></input-auto-tip>
        </input-item>
      </div>
      <input-item label="备注">
        <input-auto-tip placeholder="请输入备注" v-model="form.remark" :tip-list="option.remarks"></input-auto-tip>
      </input-item>

      <div class="space-between-x container-center">
        <el-button @click="remove()">删除记录</el-button>
        <el-button type="primary" @click="save()">确定</el-button>
      </div>


    </div>


  </div>
</template>

<script>
import InputItem from "@/components/base/layout/InputItem.vue";
import {saleorder} from "@/api/saleorder";
import {msg} from "@/assets/js/my-vue-element-ui-js";
import InputAutoTip from "@/components/system/InputAutoTip.vue";

export default {
  name: 'SaleOrderOtherPayment',
  components: {InputAutoTip, InputItem},
  props: {
    saleOrderId: "",
  },

  data() {
    return {
      form: {
        paymentTime: "",
        paymentMethod: "",
        payer: "",
        receiver: "",
        amount: "",
        remark: "",
      },

      option: {},
    };
  },

  created() {
    this.getInputOption();

    saleorder.detail(this.saleOrderId).then(vo => {
      let otherPaymentInfo = vo?.paymentDetail?.otherPaymentInfo;
      if (otherPaymentInfo) {
        this.form.paymentTime = otherPaymentInfo.paymentTime;
        this.form.paymentMethod = otherPaymentInfo.paymentMethod;
        this.form.payer = otherPaymentInfo.payer;
        this.form.receiver = otherPaymentInfo.receiver;
        this.form.amount = otherPaymentInfo.amount;
        this.form.remark = otherPaymentInfo.remark;
      }
    })
  },


  methods: {

    /**
     * 获取输入过程中的自动提示项
     */
    getInputOption() {
      saleorder.getInputOptions().then(option => {
        this.option = option;
      })
    },

    remove() {
      this.$confirm("确定删除吗？将更新商品订单状态").then(() => {
        saleorder.deleteOtherPayment(this.saleOrderId).then(res => {
          msg(res, this);
          if (res.code === 200) {
            this.$emit("updated");
          }
        })
      })
    },

    save() {
      this.$confirm("确定保存吗？将根据收款记录更新商品状态").then(() => {
        saleorder.updateOtherPayment(this.saleOrderId, this.form.paymentTime, this.form.paymentMethod, this.form.payer, this.form.receiver, this.form.amount, this.form.remark)
            .then(res => {
              msg(res, this);
              if (res.code === 200) {
                this.$emit("updated");
              }
            })
      })

    },
  },


};
</script>

<style scoped>
</style>
